import { action } from 'satcheljs';

export const updateInboxTabs = action('UPDATE_INBOX_TABS', (tabsToWrite: string[]) => ({
    tabsToWrite,
}));
